"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInlineErrorMessagesToJSON = exports.AddressInlineErrorMessagesFromJSONTyped = exports.AddressInlineErrorMessagesFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function AddressInlineErrorMessagesFromJSON(json) {
    return AddressInlineErrorMessagesFromJSONTyped(json, false);
}
exports.AddressInlineErrorMessagesFromJSON = AddressInlineErrorMessagesFromJSON;
function AddressInlineErrorMessagesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['firstName']),
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['lastName']),
        'dateOfBirth': !(0, runtime_1.exists)(json, 'dateOfBirth') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['dateOfBirth']),
        'addressName': !(0, runtime_1.exists)(json, 'addressName') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['addressName']),
        'primaryPhoneNumber': !(0, runtime_1.exists)(json, 'primaryPhoneNumber') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['primaryPhoneNumber']),
        'secondaryPhoneNumber': !(0, runtime_1.exists)(json, 'secondaryPhoneNumber') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['secondaryPhoneNumber']),
        'emailAddress': !(0, runtime_1.exists)(json, 'emailAddress') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['emailAddress']),
        'honorific': !(0, runtime_1.exists)(json, 'honorific') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['honorific']),
        'additional': !(0, runtime_1.exists)(json, 'additional') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['additional']),
        'street': !(0, runtime_1.exists)(json, 'street') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['street']),
        'houseNumber': !(0, runtime_1.exists)(json, 'houseNumber') ? undefined : (0, _1.AddressInlineErrorFromJSON)(json['houseNumber']),
        'zipCode': !(0, runtime_1.exists)(json, 'zipCode') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['zipCode']),
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : (0, _1.AddressInlineErrorFromJSON)(json['city']),
        'countryCode': !(0, runtime_1.exists)(json, 'countryCode') ? undefined : (0, _1.AddressInlineErrorMessageFromJSON)(json['countryCode']),
    };
}
exports.AddressInlineErrorMessagesFromJSONTyped = AddressInlineErrorMessagesFromJSONTyped;
function AddressInlineErrorMessagesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': (0, _1.AddressInlineErrorMessageToJSON)(value.firstName),
        'lastName': (0, _1.AddressInlineErrorMessageToJSON)(value.lastName),
        'dateOfBirth': (0, _1.AddressInlineErrorMessageToJSON)(value.dateOfBirth),
        'addressName': (0, _1.AddressInlineErrorMessageToJSON)(value.addressName),
        'primaryPhoneNumber': (0, _1.AddressInlineErrorMessageToJSON)(value.primaryPhoneNumber),
        'secondaryPhoneNumber': (0, _1.AddressInlineErrorMessageToJSON)(value.secondaryPhoneNumber),
        'emailAddress': (0, _1.AddressInlineErrorMessageToJSON)(value.emailAddress),
        'honorific': (0, _1.AddressInlineErrorMessageToJSON)(value.honorific),
        'additional': (0, _1.AddressInlineErrorMessageToJSON)(value.additional),
        'street': (0, _1.AddressInlineErrorMessageToJSON)(value.street),
        'houseNumber': (0, _1.AddressInlineErrorToJSON)(value.houseNumber),
        'zipCode': (0, _1.AddressInlineErrorMessageToJSON)(value.zipCode),
        'city': (0, _1.AddressInlineErrorToJSON)(value.city),
        'countryCode': (0, _1.AddressInlineErrorMessageToJSON)(value.countryCode),
    };
}
exports.AddressInlineErrorMessagesToJSON = AddressInlineErrorMessagesToJSON;
//# sourceMappingURL=AddressInlineErrorMessages.js.map